export var calcPreferredListHeight = function calcPreferredListHeight() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var borderless = props.borderless,
      _props$displayedItemC = props.displayedItemCount,
      displayedItemCount = _props$displayedItemC === void 0 ? 0 : _props$displayedItemC,
      _props$itemCount = props.itemCount,
      itemCount = _props$itemCount === void 0 ? 0 : _props$itemCount,
      _props$itemHeight = props.itemHeight,
      itemHeight = _props$itemHeight === void 0 ? 0 : _props$itemHeight,
      getItemHeight = props.getItemHeight;
  var preferredHeight = borderless ? 0 : 2; // if there is no item we render with the preferred count

  var preferredItemCount = itemCount === 0 ? displayedItemCount : Math.min(displayedItemCount, itemCount);

  if (typeof getItemHeight === 'function') {
    preferredHeight += Array.from({
      length: preferredItemCount
    }).reduce(function (total, _, index) {
      return total + Number(getItemHeight(index));
    }, 0);
  } else {
    preferredHeight += preferredItemCount * Number(itemHeight);
  } // list height will be undefined if the item height can not be
  // converted to a number, for example rem or a percentage string


  return isNaN(preferredHeight) ? undefined : preferredHeight;
};